import { useEffect, useState } from 'react'

const useIsMobile = (maxMobileWidth = 1000): boolean => {
  const [isMobile, setisMobile] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleResize = () => {
        setisMobile(window.innerWidth < maxMobileWidth)
      }

      handleResize()

      window.addEventListener('resize', handleResize)

      return () => {
        window.removeEventListener('resize', handleResize)
      }
    }
  }, [])

  return isMobile
}

export default useIsMobile
